module.exports = __webpack_public_path__ + "static/media/ucare.8a32224e.svg";